import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Constitution from "@/pages/Constitution";
import Elections from "@/pages/Elections";
import RNVP from "@/pages/RNVP";
import Membership from "@/pages/Membership";
import Media from "@/pages/Media";
import Donation from "@/pages/Donation";
import MemberLogin from "@/pages/MemberLogin";
import MemberDashboard from "@/pages/MemberDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Protected = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="loading-screen">
        <div className="w-10 h-10 border-4 border-emerald-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col">
            <div className="tricolor-bar w-full" />
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/constitution" element={<Constitution />} />
                <Route path="/elections" element={<Elections />} />
                <Route path="/rnvp" element={<RNVP />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/media" element={<Media />} />
                <Route path="/donation" element={<Donation />} />
                <Route path="/login" element={<MemberLogin />} />
                <Route path="/dashboard" element={<Protected><MemberDashboard /></Protected>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-center" />
          </div>
        </BrowserRouter>
      </AuthProvider>
      </SiteProvider>
    </LanguageProvider>
  );
}

export default App;
